import { Box, Container } from "@mui/material";
import Spinner from "../../components/Spinner/Spinner";

function IdxListing() {
  const config = {};
  return (
    <Container
      maxWidth="xl"
      sx={{
        minHeight: "100vh",
        pl: "2px !important",
        pr: "8px !important",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          zIndex: -1,
          top: "50%",
          left: 0,
          right: 0,
        }}
      >
        <Spinner overlay={false} />
      </Box>
      <div
        style={{ background: "white" }}
        ref={(element) => {
          try {
            const idx = window.ihfKestrel.render(config);
            element.appendChild(idx);
          } catch (error) {}
        }}
      />
    </Container>
  );
}
export default IdxListing;
